import { render } from "./ArticleCountry.vue?vue&type=template&id=df12154a&scoped=true"
import script from "./ArticleCountry.vue?vue&type=script&lang=js"
export * from "./ArticleCountry.vue?vue&type=script&lang=js"

import "./ArticleCountry.vue?vue&type=style&index=0&id=df12154a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-df12154a"

export default script